export const SIGNER_ITEM_BUTTON_NAME = 'signer-item-button';
